<template>
  <div class="box-filter">
    <el-form :model="ruleForm" ref="ruleForm" @submit.prevent v-on:submit.prevent>
      <div class="viewFilter">
        <el-row :gutter="20">
          <el-col :span="8">
           <el-form-item prop="type_person" label="Tipo">
             <el-select v-model="ruleForm.type_person" clearable style="width: 100%">
               <el-option label="Empresa" value="business" />
               <el-option label="Individual" value="individual" />
             </el-select>
           </el-form-item>
         </el-col>
         <el-col :span="8">
           <el-form-item prop="cpf" label="CPF">
             <el-input masked="true" :autofocus="true" size="large" v-model="ruleForm.cpf" v-mask="['###.###.###-##']" required />
           </el-form-item>
         </el-col>
         <el-col :span="8">
           <el-form-item prop="business_cnpj" label="CNPJ">
             <el-input masked="true" :autofocus="true" size="large" v-model="ruleForm.business_cnpj" v-mask="['##.###.###/####-##']" required />
           </el-form-item>
         </el-col>
         <el-col :span="8">
           <el-form-item prop="marketplace_id" label="Marketplace">
             <SelectSearchMarketplace :disabled="$can('2|4|5')" :model="ruleForm.marketplace_id" :isEdit="false" @handleValue=" (x) => { ruleForm.marketplace_id = x } "  />
           </el-form-item>
         </el-col>
         <el-col :span="8">
           <el-form-item prop="agent_id" label="Representante">
             <SelectSearchRepresentante :disabled="$can('4|5')" :model="ruleForm.agent_id" :isEdit="false" @handleValue=" (x) => { ruleForm.agent_id = x } " />
           </el-form-item>
         </el-col>
         <el-col :span="8">
           <el-form-item prop="mcc_id" label="MCC">
             <SelectSearchMCC :model="ruleForm.mcc_id" :isEdit="false" @handleValue=" (x) => { ruleForm.mcc_id = x } " />
           </el-form-item>
         </el-col>
          <el-col :lg="8" :md="8">
            <el-form-item prop="city_id" label="Cidade">
              <el-select
                size="large"
                v-model="ruleForm.city_id"
                style="width: 100%;"
                filterable
                remote
                reserve-keyword
                placeholder="Pesquise a Cidade"
                :remote-method="serchCity"
                :loading="loadingCity">
                <el-option v-for="(item, index) in cityOptions" :key="index" :label="item.title" :value="item.id">
                  <span style="float: left">{{ item.title }}</span>
                  <span style="float: right; color: #8492a6; font-size: 13px">DDD {{ item.iso_ddd }}</span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="8">
            <el-form-item prop="state_id" label="Estado" >
              <el-select
                size="large"
                v-model="ruleForm.state_id"
                style="width: 100%;"
                filterable
                remote
                reserve-keyword
                placeholder="Pesquise o Estado"
                :remote-method="serchState"
                :loading="loadingCity">
                <el-option v-for="(item, index) in StateOptions" :key="index" :label="item.title" :value="item.id">
                  <span style="float: left">{{ item.title }}</span>
                  <span style="float: right; color: #8492a6; font-size: 13px">{{ item.letter }}</span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" class="row-bg" justify="end">
          <el-col :xs="24" :span="15">
             <el-button  @click='searchTable(true)' type="default" size="large" style="float: right; margin-right: 20px">
              Exportar ECs
            </el-button>
            <el-button v-if="statusClearFilter" @click='clearSearch()' type="default" size="large" style="float: right; margin-right: 20px">
              Limpar Filtros
            </el-button>

          </el-col>
        </el-row>
      </div>
    </el-form>
  </div>
</template>

<script>

import SelectSearchRepresentante from "@/app/components/Representante/SelectSearchRepresentante";
import SelectSearchMarketplace from "@/app/components/Marketplace/SelectSearchMarketplace";
import SelectSearchMCC from "@/app/components/MCC/SelectSearchMCC";
import {getCity, getState} from "@/app/domains/Config/services";
import {mapGetters} from "vuex";
export default {
  name: "FilterBox",
  components: {
    SelectSearchRepresentante,
    SelectSearchMarketplace,
    SelectSearchMCC
  },
  data () {
    return {
      loadingPage: true,
      query:`?page=${this.currentPage}`,
      cityOptions: [],
      StateOptions: [],
      ruleForm: {
        searchInput: '',
        type_person: null,
        cpf: null,
        business_cnpj: null,
        agent_id: null,
        marketplace_id: null,
      },
      viewFilter: false,
      loadingCity: false,
    }
  },
  props: {
    currentPage: {
      type: Number,
      default: 1
    },
    type: {
      type: Number,
      default: 0
    }
  },
  computed: {
    ...mapGetters('Auth', ['currentUser']),
    statusClearFilter: function () {
      if (this.ruleForm.searchInput || this.ruleForm.type_person || this.ruleForm.cpf || this.ruleForm.business_cnpj || this.ruleForm.agent_id || this.ruleForm.marketplace_id) {
        return true
      }
      return false
    }
  },
  methods: {
    clearSearch () {
      this.viewFilter = false
      this.ruleForm = {
        searchInput: '',
        type_person: null,
        cpf: null,
        business_cnpj: null,
        agent_id: null,
        marketplace_id: null,
      }
      this.$emit('filter', `?page=${this.currentPage}`)
      this.query = '?page=${this.currentPage}';
    },
    async serchCity (query) {
      if (query.length > 2) {
        this.loadingCity = true
        try {
          let response = await getCity('?name='+query)
          this.cityOptions = response.data.data
          this.$set(this.ruleForm, 'country_code', 55)
        } catch (e) {
          this.$message({
            showClose: true,
            message: e.body.error.message,
            type: 'error'
          })
        } finally {
          this.loadingCity = false
        }
      }
    },
    async serchState (query) {
      if (query.length > 2) {
        this.loadingCity = true
        try {
          let response = await getState('?name='+query)
          this.StateOptions = response.data.data
        } catch (e) {
          this.$message({
            showClose: true,
            message: e.body.error.message,
            type: 'error'
          })
        } finally {
          this.loadingCity = false
        }
      }
    },
    searchTable (ex) {
      this.query = `?page=${this.currentPage}`;
      if (this.ruleForm.searchInput) {
        this.query = `${this.query}&name_store=${this.ruleForm.searchInput}`
      }
      if (this.ruleForm.type_person) {
        this.query = `${this.query}&type_person=${this.ruleForm.type_person}`
      }
      if (this.ruleForm.cpf) {
        this.query = `${this.query}&cpf=${this.ruleForm.cpf.replace(/[^\d]+/g, '')}`
      }
      if (this.ruleForm.agent_id) {
        this.query = `${this.query}&agent_id=${this.ruleForm.agent_id}`
      }
      if (this.ruleForm.marketplace_id) {
        this.query = `${this.query}&marketplace_id=${this.ruleForm.marketplace_id}`
      }
      if (this.ruleForm.business_cnpj) {
        this.query = `${this.query}&business_cnpj=${this.ruleForm.business_cnpj.replace(/[^\d]+/g, '')}`
      }
      if (this.ruleForm.mcc_id) {
        this.query = `${this.query}&mcc_id=${this.ruleForm.mcc_id}`
      }
      if (this.ruleForm.state_id) {
        this.query = `${this.query}&state_id=${this.ruleForm.state_id}`
      }
      if (this.ruleForm.city_id) {
        this.query = `${this.query}&city_id=${this.ruleForm.city_id}`
      }
       if (ex) {
        this.$emit('filterExport', this.query)
      } else {
        this.$emit('filter', this.query)
      }
    },

  },
  async mounted() {
    if (this.$can('2|4|5')) {
      this.ruleForm.marketplace_id = this.currentUser.marketplace_id
    }
    if (this.$can('4')) {
      this.ruleForm.agent_id = this.currentUser.agent_id
    }
    if (this.$can('5')) {
      this.$set(this.ruleForm, 'department_store_id', this.currentUser.department_store_id)
      this.ruleForm.department_store_id = this.currentUser.department_store_id

      this.$set(this.ruleForm, 'marketplace_id', this.currentUser.department_store.marketplace_id)
      this.ruleForm.marketplace_id = this.currentUser.department_store.marketplace_id

      this.$set(this.ruleForm, 'agent_id', this.currentUser.department_store.agent_id)
      this.ruleForm.agent_id = this.currentUser.department_store.agent_id
    }
  }
}
</script>

<style scoped>

</style>
